<img *ngIf="logo" [src]="logoIMG" [alt]="logo.mime" />
